import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { WalletConnect } from './WalletConnect';
import { Building2, TrendingUp, FileText } from 'lucide-react';

export const Navbar = () => {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav data-testid="navbar" className="sticky top-0 z-50 glassmorphism border-b border-slate-200">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" data-testid="logo-link" className="flex items-center gap-3">
            <div className="h-10 w-10 gradient-bg rounded-xl flex items-center justify-center shadow-lg shadow-indigo-500/30">
              <FileText className="h-5 w-5 text-white" />
            </div>
            <div>
              <h1 className="text-xl font-black tracking-tight text-slate-900" style={{ fontFamily: 'Chivo, sans-serif' }}>
                ChainVoice
              </h1>
              <p className="text-xs text-slate-500 font-medium">Invoice Financing</p>
            </div>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/msme"
              data-testid="msme-nav-link"
              className={`flex items-center gap-2 text-sm font-semibold transition-colors hover:text-indigo-600 ${
                isActive('/msme') ? 'text-indigo-600' : 'text-slate-600'
              }`}
            >
              <Building2 className="h-4 w-4" />
              MSME Dashboard
            </Link>
            <Link
              to="/marketplace"
              data-testid="marketplace-nav-link"
              className={`flex items-center gap-2 text-sm font-semibold transition-colors hover:text-indigo-600 ${
                isActive('/marketplace') ? 'text-indigo-600' : 'text-slate-600'
              }`}
            >
              <TrendingUp className="h-4 w-4" />
              Marketplace
            </Link>
          </div>

          <WalletConnect />
        </div>
      </div>
    </nav>
  );
};